module.exports = __webpack_public_path__ + "media/images/icons/terminal-2a55b413df712d0b103c6e419a0820c4.svg";